const getBrokers = () => {
    const brokers = localStorage.getItem("brokers")
        ? JSON.parse(localStorage.getItem("brokers"))
        : null;

    return brokers;
};

const InitialState = {
    brokers: getBrokers(),
};

const BrokerReducer = (state = InitialState, action) => {
    if (action.type === "Save_Brokers") {
        const newState = {
            ...state,
            brokers: action.payload,
        };
        localStorage.setItem("brokers", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("brokers");
        const newState = {
            brokers: null
        };
        return newState;
    }

    return state;
};

export default BrokerReducer;